const messages = {
    invalid_store: 'The selected store is invalid',
};

export default messages;
